import { Button, Grid, Typography } from '@mui/material';
import React from 'react';
import ApplicantProfileForm from '../../components/Profile/ApplicantProfileForm';
import ApplicantProfileView from '../../components/Profile/ApplicantProfileView';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const ApplicantProfilePage: React.FC = () => {
  const { keycloak } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const jobId = location.state?.jobId; // Get jobId from navigation state
  const is_hr = keycloak.hasResourceRole('hr');
  return (
    <Grid container direction="row" sx={{ marginTop: '6vh', px: { xs: 2, sm: 0 } }}>
      <Grid item container direction="column" xs={12} sm={4} md={4}>
        <Typography
          variant="h1"
          sx={{
            color: 'var(--ttg-green)',
            fontFamily: 'inherit',
            fontSize: { xs: '2.5rem', sm: '4rem', md: '6rem' },
            mb: { xs: 2, md: 8 },
          }}
        >
          Profile
        </Typography>
        {is_hr ? (
          <Grid item sx={{ width: '100%' }}>
            <Button
              variant="outlined"
              onClick={() => {
                if (jobId) {
                  navigate(`/manage-jobs/applicants/${jobId}`);
                } else {
                  navigate(-1); // Fallback to previous page
                }
              }}
              sx={{
                backgroundColor: 'white',
                color: 'var(--ttg-black)',
                borderColor: 'var(--ttg-black)',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                  borderColor: 'var(--ttg-black)',
                },
                margin: '70px 0 20px 0',
                padding: '15px 40px',
                fontSize: '18px'
              }}
            >
              Back to Applicants List
            </Button>
          </Grid>
        ) : null}
      </Grid>
      {is_hr ? <ApplicantProfileView /> : <ApplicantProfileForm />}
    </Grid>
  );
};

export default ApplicantProfilePage;
